var exports = {
  "k": "xcc377c0b--a09f60--container",
  "K": "xcc377c0b--a09f60--icon",
};

module.exports = exports;
